<template>
  <div class="animated fadeIn">
    <b-card>
      <template slot="header">
        <i class='fa fa-align-justify'></i> Submitted_List
      </template>

      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Registed_at
                <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label for="opt_is_done">Status</label>
              <br>
              <select v-model="so.opt['is_done']" @change="refresh">
                <option disabled value="">Please select Status</option>
                <option value='true'>Complete</option>
                <option value='false'>Wait</option>
              </select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_is_binary">Binary</label>
              <br>
              <select v-model="so.opt['is_binary']" @change="refresh">
                <option disabled value="">Please select option</option>
                <option value='true'>Binary</option>
                <option value='false'>Not Binary</option>
              </select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_result">Result</label>
              <br>
              <select :dsiabled="so.adv && (so.opt['is_done'] == 'true')" v-model="so.opt['result']" @change="refresh">
                <option disabled value="">Please select result</option>
                <option value='1'>Enable</option>
                <option value='0'>Disable</option>
              </select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_hash">hash</label>
              <br>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_hash" v-model="so.opt['hash']"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <label for="opt_filename">filename</label>
              <br>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_filename" v-model="so.opt['filename']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- base64 라서 검색 안됨 -->
        <!-- <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="opt_">content</label>
              <br>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_content" v-model="so.opt['content']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row> -->
        <!-- <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="opt_description">Description</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_description" v-model="so.opt['description']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row> -->
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->


      <b-row>
        <b-col sm="2">
          <b-col sm="2" v-if="view_detail !== false">
          <b-badge variant="primary">
            TOTAL : {{model.enable + model.disable}}
          </b-badge>
          <br>
          <b-badge variant="success">
            USE : {{model.enable}}
          </b-badge>
          <br>
          <b-badge variant="warning">
            Deleted : {{model.disable}}
          </b-badge>
        </b-col>
        </b-col>
        <b-col sm="10" class="md-12">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='client.username';so.skt='User';so.adv=false;so.sv='';">User</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='filename';so.skt='FileName';so.adv=false;so.sv='';">FileName</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='hash';so.skt='MD5';so.adv=false;so.sv='';">MD5</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='is_done';so.skt='Complete';so.adv=true;so.sv=1;">Done</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='result';so.skt='Result';so.adv=true;so.sv=1;">Harm</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
              <b-form-select md="5" type="text" id="ph_done" v-model="so.sv" v-show="so.skt=='Complete' && so.adv">
                <option value="1">Done</option>
                <option value="0">Wating</option>
              </b-form-select>
              <b-form-select md="5" type="text" id="ph_result" v-model="so.sv" v-show="so.skt=='result' && so.adv">
                <option value="1">Approve</option>
                <option value="0">Reject</option>
              </b-form-select>
              <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.native.enter="refresh" v-show="so.skt!='Complete' && so.skt!='Result'"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="group" slot-scope="row">{{row.item.group && row.item.group.groupname || 'deleted group'}}</template>
        <template slot="path" slot-scope="row">{{row.item.path}}</template>
        <template slot="md5" slot-scope="row">{{row.item.md5}}</template>
        <template slot="is_done" slot-scope="row">
          {{row.item.is_done ? 'Done' : 'Wating'}}</template>
        <template slot="is_alive" slot-scope="row">{{row.item.is_done ? ( row.item.is_alive ? 'Approve' : 'Reject') : '-'}}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">More</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
        </b-col>
      </b-row>
    </b-card>
    <!-- <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view> -->
  </div>
</template>

<script>
import { Api } from '@/service';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';
import moment from 'moment-timezone';
import vSelect from 'vue-select';

const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  cmd : "search",
  request : "wsf",
  offset : 0,
  limit : 10,
  adv : false,
  sk : '', "sv" : '', "skt" : '', "opt" : { },
  body : {
    sort : [ { name : "group_id" }, { name : "id", op : "desc" } ]
  }
});

export default {
  components: { DatePicker, vSelect, cSwitch },
  name : "reportList",
  props : ["auto_refresh", "enable_new", "view_detail", "partner", "addPartner"],
  data: () => {
    return {
      group_name :'',
      custom,
      codes,
      so : default_opt(),
      model : { total : 0, enable : 0, disable : 0, S : 0, U : 0, R : 0, M : 0 },
      sync : { interval : 15, stop : false, th : undefined },
    }
  },
  computed: {
    startRow : function() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    },
    fields() {
      return [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
        { key: 'group', label: 'Group', sortable: true },
        { key: 'filename', label: 'FileName', sortable: true },
        { key: 'hash', label: 'MD5', sortable: true },
        { key: 'is_done', label: 'Result', sortable: true },
        { key: 'is_alive', label: 'Status', sortable: true },
        { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%'  },
      ]
    },
  },
  methods: {
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.sv = '';
      } else { this.reset(); }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    set_op(k, v, equal=false) {
      if(equal) {
        return { name : k, value : v, op : '=' }
      }
      else if(['level', 'mode', 'group_id'].indexOf(k) > -1) {
        // console.log({ name : k, value : parseInt(v, 10), op : '=' })
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }

      return { name : k, value : `%${v}%`, op : 'like' }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { console.log('refresh'); this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    getItems: function(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        target : 'wsfinder.report', cmd : 'list',
        body : { sort : [{ name : 'id', op : 'desc'}], or : [], and : [{ name : 'is_del', value : false, op : '=' }]  },
        offset : (this.so.currentPage-1 || 0) * 10, limit: 10, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and = [{ name : 'is_del', value : false, op : '='} ] }

      if(this.partner) { so.body.and.push({ name : "partner_id", Value : this.partner.id, op : "=" }) }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_del':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'type':
              cond = this.set_op(k[i], this.codes.code_type_key[this.so.opt[k[i]]], true);
              break;
            case 'category':
              cond = this.set_op(k[i], this.codes.code_category_key[this.so.opt[k[i]]], true);
              break;
            case 'ext':
              cond = this.set_op(k[i], this.codes.code_ext_key[this.so.opt[k[i]]], true);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if( cond.value == '-' || cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return Api.Manager(so).then(rs => {
        this.so.totalRows = rs.total;
        return rs.body;
      }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail: function(item) { this.$router.push(`/wsfinder/submitted/${item.id}`); },
  	summary() {
      let and = [];
      Api.Manager({ target : 'wsfinder.report', cmd : 'summary', body : { and : and, or : [], sort : [] } })
        .then(rs => { if(rs.error) { return this.$toastr.e(rs.reason, this.$route.name) } else { this.model = Object.assign(this.model, rs.body) } })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
  },
  created: function() { console.log('report.list.vue', 'created'); },
  destroyed: function() { console.log('report.list.vue', 'destroyed'); },
  mounted: function() {
    console.log('report.list.vue', 'mounted');
    if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
  },
}
</script>
